import React from 'react';


const ExperienciaProfissional = (props) => {
	
	const { logo, altLogo, nomeEmpresa, nomeCargo, periodo, descricao, tecnologias } = props
	
	return(
		<div className="exp-profissional">
			<div className="logo-empresa">
				<img src={logo} className="img-fluid" aria-hidden="true" alt={altLogo} />
			</div>
			<div className="info-empresa">
				<h5>{nomeEmpresa}</h5>
				<b>{nomeCargo}</b>
				<p className="descricao">{periodo} <br/> {descricao}</p>
				<div className="linguagens">
					{tecnologias.map((linguagem, indice) => <span key={indice} className="badge">{linguagem}</span>)}
				</div>
			</div>
		</div>
	)
}

export default ExperienciaProfissional;
